import automaticUpdate from './automatic-update'
import companyTrends from './company-trends'
import companyUser from './company-user'
import trendoneUniverse from './trendone-universe'

export default {
    automaticUpdate,
    companyTrends,
    companyUser,
    trendoneUniverse
}
